import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../settings-action-id.constants';
import * as SettingsActions from '../../settings.actions';

class SloRequiredDocSectionsGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.sloRequiredDocSectionsGrid;
        this.filterComponent = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.icon = false;

        this.columns = [
            {title: this.$filter('translate')('ACCREDITATION.COMMON.APPLICABLE_REQUIREMENTS'),  mapper: 'name'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), SettingsActions)(this);
        this.dataAction = this.fetchEvidenceGroupRequirementsGrid;

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

SloRequiredDocSectionsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const sloRequiredDocSectionsGrid = {
    bindings: {
        title: '@',
        onRemove: '&',
    },
    controller: SloRequiredDocSectionsGridController,
    ...gridTpl
}
